export default __webpack_public_path__ + "386aa1d59fb1efa4818e057f09783c04.png";